import React from "react";
import { Popover } from "antd";
import { ShopFilled } from "@ant-design/icons";

export const PickUpPoint = ({ orderInfo }) => {
  const pickupPoint = orderInfo && (
    <div className="customerInfo">
      <p>
        Name: <span>{orderInfo.retailer.name}</span>
      </p>
      <p>
        Instructions: <span>{orderInfo.pickupPoint.instructions}</span>
      </p>
      {orderInfo.retailer.officeAddress && (
        <p>
          Address: <span>{orderInfo.retailer.officeAddress}</span>
        </p>
      )}
    </div>
  );

  return (
    <Popover content={pickupPoint} title="PickUpPoint" trigger="click">
      <div style={{ width: "25px", height: "25px", cursor: "pointer" }}>
        <ShopFilled style={{ color: "green", fontSize: "18px" }} />
      </div>
    </Popover>
  );
};
